import {
  SET_TRANSFER,
  SET_TRANSFER_FAILED,
  SET_TRANSFER_SUCCESS,
  RESET_TRANSFER_ERROR,
  SET_RESOURCE,
  SET_TRANSFER_DUPLICATED,
  TRANSACTION_TIMEOUT,
  SET_TRANSACTION_TIMEOUT,
  RESET_DUPLICATE_TRANSACTION,
  SET_FNZ_TIMEOUT,
  FNZ_TIMEOUT,
} from "./constant";

const initialState = {
  switched: {},
  transfer: {},
  resource: null,
  transferLoading: false,
  transferError: null,
  duplicateTransaction: false,
  // duplicateTransactionToken: null,
  // validationTtl: 0,
};

export default function switchingReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case SET_RESOURCE:
      return { ...state, resource: payload };
    case SET_TRANSFER:
      return {
        ...state,
        transferLoading: true,
      };
    case SET_TRANSFER_SUCCESS:
      return {
        ...state,
        transfer: payload,
        transferLoading: false,
      };
    case SET_TRANSFER_FAILED:
      return {
        ...state,
        transfer: {},
        transferError: payload,
        transferLoading: false,
      };
    case SET_TRANSFER_DUPLICATED:
      return {
        ...state,
        transfer: {},
        duplicateTransaction: true,
        // duplicateTransactionToken: payload?.duplicateTransactionToken || null,
        // validationTtl: payload?.validationTtl || 0,
        transferLoading: false,
      };
    case SET_TRANSACTION_TIMEOUT:
      return {
        ...state,
        transfer: {},
        transferError: TRANSACTION_TIMEOUT,
        transferLoading: false,
      };
    case SET_FNZ_TIMEOUT:
      return {
        ...state,
        transfer: {},
        transferError: FNZ_TIMEOUT,
        transferLoading: false,
      };
    case RESET_TRANSFER_ERROR:
      return {
        ...state,
        transferError: null,
      };
    case RESET_DUPLICATE_TRANSACTION:
      return {
        ...state,
        transferError: null,
        duplicateTransaction: false,
        // duplicateTransactionToken: null,
        // validationTtl: 0,
      };
    default:
      return state;
  }
}
